import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from './_core/modules/authentication/authentication.guard';

const routes: Routes = [
  { path: '', loadChildren: './home-page/home-page.module#HomePageModule', canActivate: [  AuthenticationGuard ] },
  { path: 'login', loadChildren: './login-page/login-page.module#LoginPageModule' },
  { path: '**', redirectTo: './login-page/login-page.module#LoginPageModule' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
